// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
}

.modal-content {
  position: relative;
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  max-width: 600px;
  width: 90%;
  max-height: 80vh;
  overflow-y: auto;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  font-size: 1rem; /* Set a base font-size for normal readability */
}

h2, h3 {
  margin-top: 0.5em;
  margin-bottom: 0.5em;
}

.modal-content ul {
  list-style-type: none; /* Remove bullet points */
  padding: 0;
  margin-left: 0;
}

.modal-content p, .modal-content ul, .modal-content li {
  text-align: justify;
  margin-bottom: 10px;
  font-size: 1rem; /* Ensures consistent font size */
}

.close-button {
  display: block;
  margin-top: 20px;
  padding: 10px 20px;
  background: #f1f1f1;
  border: none;
  cursor: pointer;
  color: #333;
  text-align: center;
  width: auto;
  align-self: center; /* Center the button horizontally */
  margin-bottom: 10vh;
}

/* Media Queries for Mobile Devices */
@media (max-width: 767px) {
  .modal-content {
    width: 100%; /* Full width on smaller screens */
    max-width: 100%; /* Override any max-width */
    height: 100%; /* Full screen height */
    max-height: 100%; /* Ensure it is full height */
    border-radius: 0; /* Optional: remove border-radius for full screen usage */
    overflow-y: auto; /* Allows for scrolling within the modal */
  }
}

/* Media Queries for Tablets */
@media (min-width: 768px) and (max-width: 1366px) {
  .modal-content {
    font-size: 1.25rem; /* Increase the base font size for better readability */
  }

  h2 {
    font-size: 1.75rem; /* Larger but not too large for headers */
  }

  h3 {
    font-size: 1.5rem; /* Slightly smaller than h2 but larger than body text */
  }

  p, ul, li {
    font-size: 1.5rem !important; /* Ensure all text is comfortably readable */
  }
}
`, "",{"version":3,"sources":["webpack://./src/PolicyModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,oCAAoC;EACpC,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,wCAAwC;EACxC,eAAe,EAAE,gDAAgD;AACnE;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB,EAAE,yBAAyB;EAChD,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,eAAe,EAAE,iCAAiC;AACpD;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,kBAAkB,EAAE,mCAAmC;EACvD,mBAAmB;AACrB;;AAEA,qCAAqC;AACrC;EACE;IACE,WAAW,EAAE,kCAAkC;IAC/C,eAAe,EAAE,2BAA2B;IAC5C,YAAY,EAAE,uBAAuB;IACrC,gBAAgB,EAAE,6BAA6B;IAC/C,gBAAgB,EAAE,yDAAyD;IAC3E,gBAAgB,EAAE,0CAA0C;EAC9D;AACF;;AAEA,8BAA8B;AAC9B;EACE;IACE,kBAAkB,EAAE,uDAAuD;EAC7E;;EAEA;IACE,kBAAkB,EAAE,yCAAyC;EAC/D;;EAEA;IACE,iBAAiB,EAAE,uDAAuD;EAC5E;;EAEA;IACE,4BAA4B,EAAE,4CAA4C;EAC5E;AACF","sourcesContent":[".modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 1000;\n}\n\n.modal-content {\n  position: relative;\n  background-color: white;\n  padding: 20px;\n  border-radius: 8px;\n  max-width: 600px;\n  width: 90%;\n  max-height: 80vh;\n  overflow-y: auto;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  font-size: 1rem; /* Set a base font-size for normal readability */\n}\n\nh2, h3 {\n  margin-top: 0.5em;\n  margin-bottom: 0.5em;\n}\n\n.modal-content ul {\n  list-style-type: none; /* Remove bullet points */\n  padding: 0;\n  margin-left: 0;\n}\n\n.modal-content p, .modal-content ul, .modal-content li {\n  text-align: justify;\n  margin-bottom: 10px;\n  font-size: 1rem; /* Ensures consistent font size */\n}\n\n.close-button {\n  display: block;\n  margin-top: 20px;\n  padding: 10px 20px;\n  background: #f1f1f1;\n  border: none;\n  cursor: pointer;\n  color: #333;\n  text-align: center;\n  width: auto;\n  align-self: center; /* Center the button horizontally */\n  margin-bottom: 10vh;\n}\n\n/* Media Queries for Mobile Devices */\n@media (max-width: 767px) {\n  .modal-content {\n    width: 100%; /* Full width on smaller screens */\n    max-width: 100%; /* Override any max-width */\n    height: 100%; /* Full screen height */\n    max-height: 100%; /* Ensure it is full height */\n    border-radius: 0; /* Optional: remove border-radius for full screen usage */\n    overflow-y: auto; /* Allows for scrolling within the modal */\n  }\n}\n\n/* Media Queries for Tablets */\n@media (min-width: 768px) and (max-width: 1366px) {\n  .modal-content {\n    font-size: 1.25rem; /* Increase the base font size for better readability */\n  }\n\n  h2 {\n    font-size: 1.75rem; /* Larger but not too large for headers */\n  }\n\n  h3 {\n    font-size: 1.5rem; /* Slightly smaller than h2 but larger than body text */\n  }\n\n  p, ul, li {\n    font-size: 1.5rem !important; /* Ensure all text is comfortably readable */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
